<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Terms
        ref="terms"
        :form-data="formData"
      />
    </el-card>
  </div>
</template>
<script>
import Terms from '@/components/Application/Manage/Carriers/Carrier/Terms'
export default {
  components: {
    Terms
  },
  data () {
    return {
      pageTitle: 'Terms',
      breadcrumb: {
        name: 'Terms',
        route: { name: 'manage-carriers-carrier-configurations-pickup' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: {},
      formData: {
        terms: null
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
      }).then(res => {
        this.carrier = res
        this.formData.terms = this.carrier.terms.replace(/<br\s*[/]?>/gi, '\r')
      })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.terms = this.formData.terms.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      this.carrier.update()
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>
